import { baseVueController } from "./baseVueController";

//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * エラー画面画面コントローラクラス
 * */
export class errorController extends baseVueController {

	public init(): void {
		// エラー時のボタン遷移先
		this.SetErrorPageInfo();
	}

	public initRetailer(): void {
		// NOP
	}

	public btnClickReturnFlow(event: JQueryEventObject): void {
		// NOP
	}

	public btnClickNextFlow(event: JQueryEventObject): void {
		// NOP			
	}
}